import { useState, useEffect } from 'react';
import { Users, FileText, CreditCard, DollarSign } from 'lucide-react';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { adminStats, adminUsers } from '../../api';

const TDATA=[{day:'Mon',v:120},{day:'Tue',v:185},{day:'Wed',v:148},{day:'Thu',v:212},{day:'Fri',v:193},{day:'Sat',v:82},{day:'Sun',v:61}];
const GDATA=[{m:'Jul',u:12},{m:'Aug',u:28},{m:'Sep',u:41},{m:'Oct',u:58},{m:'Nov',u:75},{m:'Dec',u:94}];

const RC={admin:'bg-red-100 text-red-600',paid:'bg-green-100 text-green-600',gifted:'bg-purple-100 text-purple-600',free:'bg-gray-100 text-gray-600',guest:'bg-orange-100 text-orange-600'};

export default function Dashboard() {
  const [stats,setStats] = useState(null);
  const [users,setUsers] = useState([]);

  useEffect(()=>{
    adminStats().then(r=>setStats(r.data)).catch(()=>{});
    adminUsers().then(r=>setUsers(r.data.users?.slice(0,5)||[])).catch(()=>{});
  },[]);

  const cards = [
    ['Total Users',       stats?.totalUsers||'—', <Users size={18}/>,    'text-blue-600 bg-blue-50'],
    ['Paid Subscribers',  stats?.paidUsers||'—',  <CreditCard size={18}/>,'text-green-600 bg-green-50'],
    ['Documents',         stats?.totalDocs||'—',  <FileText size={18}/>, 'text-yellow-600 bg-yellow-50'],
    ['Monthly Revenue',   stats?`$${stats.revenue}`:'—', <DollarSign size={18}/>,'text-purple-600 bg-purple-50'],
  ];

  return(
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
        {cards.map(([l,v,icon,c],i)=>(
          <div key={i} className="bg-white rounded-2xl p-4 shadow-sm border border-gray-100">
            <div className={"w-9 h-9 rounded-xl flex items-center justify-center mb-3 "+c}>{icon}</div>
            <div className="text-xl font-bold text-gray-800">{v}</div>
            <div className="text-xs text-gray-400 mt-0.5">{l}</div>
          </div>
        ))}
      </div>
      <div className="grid md:grid-cols-2 gap-6 mb-6">
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <h3 className="font-semibold text-sm text-gray-600 mb-4">Weekly Traffic</h3>
          <ResponsiveContainer width="100%" height={150}>
            <BarChart data={TDATA}><CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6"/><XAxis dataKey="day" tick={{fontSize:10}}/><YAxis tick={{fontSize:10}}/><Tooltip/><Bar dataKey="v" fill="#1e3a5f" radius={[4,4,0,0]}/></BarChart>
          </ResponsiveContainer>
        </div>
        <div className="bg-white rounded-2xl p-5 shadow-sm border border-gray-100">
          <h3 className="font-semibold text-sm text-gray-600 mb-4">User Growth</h3>
          <ResponsiveContainer width="100%" height={150}>
            <LineChart data={GDATA}><CartesianGrid strokeDasharray="3 3" stroke="#f3f4f6"/><XAxis dataKey="m" tick={{fontSize:10}}/><YAxis tick={{fontSize:10}}/><Tooltip/><Line type="monotone" dataKey="u" stroke="#eab308" strokeWidth={2.5} dot={{fill:'#eab308',r:3}}/></LineChart>
          </ResponsiveContainer>
        </div>
      </div>
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="px-5 py-3 border-b text-sm font-semibold text-gray-700">Recent Users</div>
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs text-gray-400 bg-gray-50 border-b"><th className="px-4 py-2.5">Name</th><th className="px-4 py-2.5">Email</th><th className="px-4 py-2.5">Role</th><th className="px-4 py-2.5">Last Active</th></tr></thead>
          <tbody>{users.map(u=>(
            <tr key={u.id} className="border-b border-gray-50 hover:bg-gray-50">
              <td className="px-4 py-2.5 font-medium">{u.name}</td>
              <td className="px-4 py-2.5 text-gray-400 text-xs">{u.email}</td>
              <td className="px-4 py-2.5"><span className={"text-xs px-2 py-0.5 rounded-full font-semibold "+(RC[u.role]||'')}>{u.role}{u.role==='gifted'?' 🎁':''}</span></td>
              <td className="px-4 py-2.5 text-gray-400 text-xs">{u.last_active_at?new Date(u.last_active_at).toLocaleDateString():'—'}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    </>
  );
}
